var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.128 4.146l8.134 8.134a.5.5 0 010 .708l-7.128 7.127a.5.5 0 01-.707 0l-8.134-8.133a.5.5 0 01-.143-.412l.746-6.382a.5.5 0 01.438-.438l6.382-.747a.5.5 0 01.412.143zm-8.896 8.896a2 2 0 01-.572-1.646l.746-6.382A2 2 0 015.16 3.26l6.382-.746a2 2 0 011.646.572l8.134 8.134a2 2 0 010 2.828l-7.128 7.128a2 2 0 01-2.828 0l-8.134-8.134zm6.22-3.944A1.25 1.25 0 107.684 7.33a1.25 1.25 0 001.768 1.768z",
    fill: "currentColor"
  })));
}
export default SvgTag;